import { faCheckDouble, faDice, faUpload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { SendButtonAiFull, SendButtonAiIconOnly, SendButtonAiWithouText } from "../../ui/SendButtonAI";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { useTranslation } from "react-i18next";
import { PromptAreaProps } from "../../../types/miniTools/generations";

export const PromptArea = ({
    functionsDisabled,
    promptNegative,
    promptPositive,
    credits,
    showSendButton=true,
    placeholderPromptNegative,
    placeholderPromptPositive,
    titleUploadFile,
    acceptFiles='image/png,image/jpg,image/jpeg',
    onCheckPrompt,
    onInputChange,
    onUploadFile,
    onRandomPrompt,
    onGenerateImage
}:PromptAreaProps) => {
    const isMobile = useIsMobile();
    const { t } = useTranslation(['generation','imageStudio']);
    
    return(
        <>
            <div className="row p-2 pb-1 align-items-end">
                {/* Positive Prompt */}
                <div className="col p-1" data-tour="prompt-area">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <label
                            htmlFor="promptPositive"
                            className="form-label mb-0"
                        >
                            {t("prompt.positive")}
                        </label>

                        { (onRandomPrompt || onCheckPrompt || onUploadFile) && (
                                <div className="d-flex align-items-center">
                                    {   onUploadFile && (
                                            <>
                                                <label htmlFor="fileuploadImage" className=' fw-bold me-2' title={titleUploadFile ?? t("uploadImage")}>
                                                    <FontAwesomeIcon icon={faUpload} className='p-0' />
                                                </label>
                                                <input
                                                    id = 'fileuploadImage'
                                                    title={titleUploadFile ?? t("uploadImage")}
                                                    type= 'file'
                                                    accept={acceptFiles}
                                                    onChange={event => onUploadFile(event)}
                                                    hidden
                                                />
                                            </>
                                            )
                                    }
                                    {   onRandomPrompt && (
                                            <button
                                                type="button"
                                                title={t("imageStudio:page.randomPromptButton")}
                                                className="btn border-0 bg-transparent p-0 ms-1"
                                                disabled={functionsDisabled}
                                                onClick={() => onRandomPrompt()}
                                            >
                                                <FontAwesomeIcon icon={faDice} />
                                            </button>
                                            )
                                    }
                                    {   onCheckPrompt && (
                                            <button
                                                type="button"
                                                title={t("imageStudio:page.checkPromptButton")}
                                                className="btn border-0 bg-transparent p-0 ms-1"
                                                disabled={functionsDisabled}
                                                onClick={() => onCheckPrompt()}
                                            >
                                                <FontAwesomeIcon icon={faCheckDouble} />
                                            </button>
                                            )
                                    }
                                </div>
                            )
                        }
                    </div>

                    <textarea
                        className="form-control"
                        id="promptPositive"
                        name="promptPositive"
                        rows={3}
                        value={promptPositive}
                        onChange={onInputChange}
                        placeholder={placeholderPromptPositive ?? t("placeholder.positive")}
                    />
                </div>

                {/* Negative Prompt */}
                {
                    promptNegative!== undefined && (
                        <div className="col p-1">
                            <div className="d-flex align-items-center mb-2">
                                <label
                                    htmlFor="promptNegative"
                                    className="form-label mb-0"
                                >
                                    {t("prompt.negative")}
                                </label>
                            </div>

                            <textarea
                                className="form-control"
                                id="promptNegative"
                                name="promptNegative"
                                rows={3}
                                value={promptNegative}
                                onChange={onInputChange}
                                placeholder={placeholderPromptNegative ?? t("placeholder.negative")}
                            />
                        </div>
                    )
                }
                

                {/* Generate */}
                { showSendButton && (
                        <div className="col-auto p-1 d-flex flex-column justify-content-center text-start" data-tour="generate-button">
                            {isMobile ? (
                                <SendButtonAiWithouText
                                    onClick={() => onGenerateImage()}
                                    credits={credits}
                                    title={t("generateImage")}
                                    disabled={functionsDisabled}
                                    showAILogo={false}
                                />
                            ) : (
                                <SendButtonAiFull
                                    onClick={() => onGenerateImage()}
                                    title={t("generateImage")}
                                    credits={credits}
                                    disabled={functionsDisabled}
                                />
                            )}
                        </div>
                    )
                }
            </div>
        </>
    )
}